'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm.data ? _c('div', {
      class: ['bottom-link', {
        'bottom-link--short': _vm.shortBottom
      }]
    }, _vm._l(_vm.data, function (item, index) {
      return _c('span', {
        directives: [{
          name: "tap",
          rawName: "v-tap"
        }],
        key: index,
        on: {
          "click": item.onClick
        }
      }, [_vm._v(" " + _vm._s(item.text) + " ")]);
    }), 0) : _vm._e();
  },
  staticRenderFns: [],
  name: 'bottom-link',
  props: {
    data: Array,
    shortBottom: {
      type: Boolean,
      default: false
    }
  }
});

exports.default = index;
